import { pushDataLayerEvent } from './datalayer.js';

class CollectionFilter {
  constructor () {
    this.$window                 = $(window);
    this.$filterForm             = $('form#filter');
    this.$filterInputs           = this.$filterForm.find('input[type="checkbox"]');
    this.$filterSpectrumsInputs  = $('#filter-spectrums input[type="checkbox"]');
    this.$filterBadgeWrapper     = $('.filters__active-list');
    this.$filterGroups           = $('.filter__group');
    this.$sortForm               = $('#sort-by-price');
    this.$mobileFilterButton     = $('.filter__mobile-button');
    this.$filterColumn           = $('.filter__column');
    this.$filterCloseButton      = this.$filterColumn.find('.btn-close');
    this.$clearFiltersButton     = $('.filters__clear');
    this.$seeAllButton           = this.$filterForm.find('.filter__see-all');
    this.$filterNoResultsMessage = $('.filter__no-results');
    this.$productCardsWrapper    = $('.filter__products');
    this.$productCards           = this.$productCardsWrapper.find('.product__card');
    this.$filterFader            = $('.filter__fader');
    this.fadeSpeed               = 100;
    this.filterParams            = ['spectrums', 'brands']; // An array of filter-related query string params that will be handled uniquely when parsing the URL.
    this.otherParams             = []; // A dynamically-populated array of { key: value } pairs of 'other' query-string params (non-filter-related) and their values to preserve in the URL as it gets updated via filters.

    this.init();

    document.addEventListener(
      "refreshTemplate",
      (e) => {
        // The 'true' argument is used to specify this is being called within an 'addToCart' ajax context and we do not want to update the URL.
        this.handleFormChange(true);
        this.sortByPrice(this.$sortForm);
      },
      false,
    );
  }

  /**
   * Returns an array of filter group names, e.g. ['spectrums', 'brands'].
   *
   * @returns {array} of filter group names.
   */
  getFilterGroupNames = () => {
    const filters = [];

    this.$filterGroups.each((i, el) => {
      const $el = $(el);
      if ($el.data('filter')) {
        filters.push($el.data('filter'));
      }
    });

    return filters;
  };

  /**
   * Returns an object of all active filters.
   *
   * @returns {object} of active filters as { 'name': [values]}.
   */
  getSelectedFilterVals = () => {
    const data = {};
    this.$filterGroups.each((i, filterGroup) => {
      const $filterGroup = $(filterGroup);
      const selected = [];
      const $checkboxes = $filterGroup.find('input[type="checkbox"');
      $checkboxes.each((i, checkbox) => {
        const $checkbox = $(checkbox);
        if (true === $checkbox.prop('checked')) {
          selected.push($checkbox.val());
        }
      });
      if (selected.length) {
        data[$filterGroup.data('filter')] = selected;
      }
    });
    return data;
  };

  /**
   * Remove all active filters by triggering clicks on the corresponding badges.
   */
  clearFilters = () => {
    const $filterBadges = $('.filter__badge');
    $filterBadges.each((i, el) => $(el).trigger('click'));
    this.$clearFiltersButton.addClass('d-none');
  };

  /**
   * Returns an array of products that meet the filter criteria.
   *
   * @returns {array} of all products within the filter.
   */
  getFilteredProducts = () => {
    const shownProducts = [];
    const filters = this.getFilterGroupNames();
    const data = this.getSelectedFilterVals();

    this.$productCards.each((i, el) => {
      const $el = $(el);
      // Though initially drafted to use an 'or' logic with regard to the filters,
      // this has been revised to use an 'and' logic. If a product/$el does not
      // have, e.g., a matching brand AND spectrum color (assuming both are selected),
      // it will be excluded.
      let excludeProduct = false;
      for (const filter of filters) {
        // Skip to the next product/$el in the $productCards each loop if
        // the product has already been excluded by failing to match a filter.
        if (!excludeProduct) {
          // If the product/$el has the filter key (e.g. 'brands', 'spectrums')...
          if (data[filter]) {
            // ...And the value of the key matches the value of the filter...
            if (data[filter].includes($el.data(filter))) {
              // ...Push the product/$el to the array of products to show.
              shownProducts.push($el);
            } else {
              // ...But if the value of the key doesn't match the value of the filter,
              // toggle the excludeProduct boolean check.
              excludeProduct = true;
              // ...And if the $el/product has already been added by an 'earlier' filter,
              // remove it.
              if (shownProducts.includes($el)) {
                const index = shownProducts.indexOf($el);
                if (index !== -1) {
                  shownProducts.splice(index, 1);
                }
              }
            }
          }
        }
      }
    });

    return shownProducts;
  };

  /**
   * Show all product cards.
   */
  showAllProducts = () => {
    if (this.$productCards.length) {
      this.hideNoResultsMessage();
      this.$productCards.show();
    }
  };

  /**
   * Fades in all the products that are within the current filter parameters.
   *
   */
  showSelectedProducts = () => {
    const productsArr = this.getFilteredProducts();

    this.$productCards.hide();
    if (productsArr.length) {
      this.hideNoResultsMessage();
      productsArr.forEach((el) => $(el).show());
    } else {
      this.showNoResultsMessage();
    }
  };

  /**
   * Show the 'No Results...' message div.
   */
  showNoResultsMessage = () => {
    this.$filterNoResultsMessage.removeClass('d-none');
  };

  /**
   * Hide the 'No Results...' message div.
   */
  hideNoResultsMessage = () => {
    this.$filterNoResultsMessage.addClass('d-none');
  };

  /**
   * Sorts product cards by price. (Or index if no price selected.)
   * Gets order – asc or desc – from within the sort-by-price form.
   *
   * @param {jQuery} $priceForm jQuery object of the sort-by-price form.
   *
   */
  sortByPrice = ($priceForm) => {
    const order = $priceForm.find('select').val();
    if ('asc' === order || 'desc' === order) {
      const prices = [];

      this.$productCards.each((index, element) => {
        prices.push(parseInt(element.dataset.price));
      });

      prices.sort((a, b) => ('asc' === order ? a - b : b - a));

      this.$productCards.each((index, element) => {
        element.style.order = prices.indexOf(parseInt(element.dataset.price));
      });
    } else {
      this.$productCards.each((index, element) => {
        element.style.order = element.dataset.index;
      });
    }
  };

  /**
   * Builds a badge-style UI component with data from a filter input.
   * Prepends the badge to the screen.
   *
   * @param {jQuery} $filterInput jQuery object of the clicked filter input.
   *
   */
  addBadge = ($filterInput) => {
    const html = `<a class="filter__badge d-flex gap-2 align-items-center badge text-dark" role="button" data-filter="${$filterInput.data(
      'filter-type'
    )}" data-value="${$filterInput.val()}"><span>${$filterInput.data(
      'label'
    )}</span> <span class="btn-close"></span></a>`;

    const $badgeAlreadyExists = $(
      `.badge[data-filter="${$filterInput.data('filter-type')}"][data-value="${$filterInput.val()}"]`
    );

    if ($badgeAlreadyExists.length) {
      $badgeAlreadyExists.remove();
    } else {
      this.$filterBadgeWrapper.prepend(html);
    }

    if (this.$filterBadgeWrapper.find('.badge').length) {
      this.$clearFiltersButton.removeClass('d-none');
    } else {
      this.$clearFiltersButton.addClass('d-none');
    }
  };

  /**
   * Removes the clicked badge-style UI component.
   * Toggles a click on the corresponding input to update results.
   *
   * @param {jQuery} $badge jQuery object of the clicked badge.
   *
   */
  removeBadge = ($badge) => {
    const $targetFilter = this.$filterForm.find(`[data-filter="${$badge.data('filter')}"]`);
    const $targetInput = $targetFilter.find(`input[value="${$badge.data('value')}"]`);
    $targetInput.click();
    $badge.remove();

    if (this.$filterBadgeWrapper.find('.badge').length) {
      this.$clearFiltersButton.removeClass('d-none');
    } else {
      this.$clearFiltersButton.addClass('d-none');
    }
  };

  /**
   * Returns true if window is below 992px in width.
   *
   * @returns {boolean} True if window has max-width of 991px.
   */
  isMobile = () => {
    return window.matchMedia('(max-width: 991px)').matches;
  };

  /**
   * Repositions the mobile filter's top and height values to sit under the headaer.
   *
   */
  resizeMobileFilter = () => {
    if (this.isMobile()) {
      const height = this.getFilterHeight();
      this.$filterColumn.css({ top: `${height}px`, height: `calc(100vh - ${height}px)` });
    } else {
      this.$filterColumn.css({ top: 'initial', height: 'initial' });
    }
  };

  /**
   * Gets a height value to set the mobile filter's top and height valuees.
   *
   * @return {number} height, an an int, to base the filter's top and height values on.
   *
   */
  getFilterHeight = () => {
    const $header = $('header.header');
    const $headerTop = $('.header__top');

    const height =
      $header.outerHeight() +
      ($headerTop.outerHeight() >= this.$window.scrollTop() ? $headerTop.outerHeight() - this.$window.scrollTop() : 0);
    return height;
  };

  /**
   * Toggles the filter open/closed (for mobile). Also
   * used to reset the filter to its "closed" state on
   * resize up to desktop.
   *
   * @param {boolean} open
   */
  toggle = (open = true) => {
    $('.filter__column')[open ? 'addClass' : 'removeClass']('active');
    $('body')[open ? 'addClass' : 'removeClass']('overflow-hidden');
  };


  /**
   * Fades results out, runs a passed function, then fades them back in.
   *
   * @param {function} fn Function that runs in between fade out and fade in (such as sorting).
   */
  fadeResults = (fn) => {
    this.$filterFader.fadeOut(this.fadeSpeed, () => {
      fn();
      this.$filterFader.fadeIn(this.fadeSpeed);
    });
  };

  /**
   * Runs a sequence of semi-conditional form-handler methods.
   *
   * @param {boolean} addToCart if set to true, is being called from cartUpdater and is used to skip URL updating.
   */
  handleFormChange = (addToCart = false) => {
    const filters = this.getSelectedFilterVals();

    if (!addToCart) {
      this.updateURL(filters);
    }

    if (addToCart) {
      // If this is called in an 'addToCart'/Ajax contect (i.e. addToCart === true),
      // we'll have to reassign the relevant variables with the newly-loaded data.
      this.$productCardsWrapper = $('.filter__products');
      this.$productCards        = this.$productCardsWrapper.find('.product__card');
    }

    if (Object.keys(filters).length !== 0) {
      this.showSelectedProducts();
      pushDataLayerEvent({
        event: 'action',
        actionName: 'filter applied',
        attributes: {
          filters,
        },
      });
    } else {
      this.showAllProducts();
    }
  };

  /**
   * Runs a sequence of conditional event-handler method:
   * Calls the addBadge function, passing the clicked target.
   * (But only if it's a 'genuine' click, not a code-triggered one).
   *
   * @param {object} evt Event object coming from filter input click.
   */
  handleFilterInputClick = (evt) => {
    if(!evt) return;
    if (Object.prototype.hasOwnProperty.call(evt, 'originalEvent')) {
      this.addBadge($(evt.target));
    }
  }

  /**
   * Runs a sequence of semi-conditional form-handler methods.
   *
   * @param {object} evt Event object coming from Spectrums input click.
   */
  handleSpectrumsInputClick = (evt) => {
    $(evt.target).parent().find('.filter__spectrum-check').toggleClass('active');
  }

   /**
   * Handles badge click by calling removeBadge function, passing the event target.
   *
   * @param {object} evt Event object coming from filter badge clicks.
   */
  handleBadgeClick = (evt) => {
    evt.preventDefault();
    const $badge = $(evt.currentTarget);
    this.removeBadge($badge);
  }

  /**
   * Handles 'See All [Brands]' button click: removes d-none from hidden brands and hides the button.
   *
   * @param {object} evt Event object coming from filter badge clicks.
   */
  handleSeeAllButtonClick = (evt) => {
    evt.preventDefault();

    const $target = $(evt.target);

    $target.closest('.filter__group').find('.form-check.d-none').removeClass('d-none');
    $target.remove();
  }

  /**
   * Collects all event handler bindings in one spot, invoked in init().
   *
   */
  bindEventHandlers = () => {
    this.$window.on('resize scroll', () => {
      this.resizeMobileFilter();
    });

    this.$filterForm.on('change', () => {
      this.fadeResults(() => {
        this.handleFormChange();
      });
    });

    this.$filterInputs.on('click', (evt) => {
      this.handleFilterInputClick(evt);
    });

    this.$clearFiltersButton.on('click', () => {
      this.fadeResults(() => {
        this.clearFilters();
      });
    });

    this.$filterSpectrumsInputs.on('click', (evt) => {
      this.handleSpectrumsInputClick(evt);
    });

    this.$filterBadgeWrapper.on('click', '.badge', (evt) => {
      this.handleBadgeClick(evt);
    });

    this.$sortForm.on('change', () => {
      this.fadeResults(() => {
        this.sortByPrice(this.$sortForm);
      });
    });

    this.$mobileFilterButton.on('click', () => {
      this.toggle();
    });

    this.$filterCloseButton.on('click', () => {
      this.toggle(false);
    });

    this.$window.on('resize', () => {
      if (!this.isMobile()) this.toggle(false);
    });

    this.$seeAllButton.on('click', (evt) => {
      this.handleSeeAllButtonClick(evt);
    });
  }

  /**
   * Updates the URL's query string and window history based on currently selected values.
   *
   * @param {object} filters Object of selected filter values.
   *
   */
  updateURL = (filters) => {
    const paramsObj = {};

    for (let entry in filters) {
      let compiledValue = '';
      filters[entry].forEach((filter) => {
        compiledValue += `${filter},`;
      });
      compiledValue = compiledValue.substring(0, compiledValue.length - 1);
      paramsObj[entry] = compiledValue;
    }
    for (let entry in this.otherParams) {
      paramsObj[entry] = this.otherParams[entry];
    }
    if (Object.keys(paramsObj).length > 0) {
      history.pushState(null, '', `${window.location.pathname}?${$.param(paramsObj)}`);
    } else {
      history.pushState(null, '', window.location.pathname);
    }
  };

  /**
   * Parses the URL's query string and updates the UI based on its contents.
   * To be fired on page load/document ready, e.g.
   *
   */
  parseURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params    = Object.fromEntries(urlParams.entries());
    if (params) {
      for (const param in params) {
        if (!this.filterParams.includes(param)) {
          this.otherParams[param] = params[param];
          continue;
        }
        const splitValues = params[param].split(',');
        splitValues.forEach((value) => {
          if (value) {
            const $thisInput = this.$filterForm.find(`#filter-${param}`).find(`input[value="${value}"]`);
            $thisInput.click();
            this.addBadge($thisInput);
            $thisInput.parent().find('.filter__spectrum-check').toggleClass('active');
          }
        });
      }
      this.handleFormChange();
    }
  };

  /**
   * Init function to:
   *
   * a. Resize the mobile filter on load.
   * b. Parse the URL (and run any consequent filterings).
   * d. Fire function that collects all event handler bindings.
   */
  init = () => {
    this.resizeMobileFilter();
    this.parseURL();
    this.bindEventHandlers();
    if(this.$filterFader.hasClass('opacity-0')) {
      this.$filterFader.removeClass('opacity-0');
    }
  }
}

(($) => {
  $(() => {
    if ($('body').data('path').indexOf('/collections/') !== -1) {
      new CollectionFilter();
    }
  });
})(jQuery);
